import React, { useEffect, useState } from 'react';
import './PuzzlePage.css';

export default function PhotoGallery() {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null); // { filename, feeling, timestamp }

  useEffect(() => {
    fetch('https://api.laviopaperie.com/photos')
      .then(r => r.json())
      .then(r => setPhotos(r.photos || []))
      .finally(()=>setLoading(false));
  }, []);

  return (
    <div className="puzzle-bg">
      <div className="puzzle-container">
        <div className="puzzle-title">History of Feelings 📷</div>
        {loading && <div style={{textAlign:'center'}}>Loading...</div>}
        {!loading && !photos.length && <div style={{textAlign:'center'}}>Belum ada unggahan.</div>}
        <div className="photog-table-wrap">
          <table className="photog-table">
            <thead>
              <tr><th>No</th><th>Timestamp</th><th>Feeling</th><th>Action</th></tr>
            </thead>
            <tbody>
              {photos.map((p,i)=>(
                <tr key={p.id}>
                  <td>{i+1}</td>
                  <td>{p.timestamp && p.timestamp.replace('T',' ').replace(/\..+/, '')}</td>
                  <td>{p.feeling}</td>
                  <td><button className="puzzle-btn photo-view-btn" onClick={()=>setModal(p)}>View</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {modal && (
        <div className="cam-overlay" onClick={()=>setModal(null)}>
          <div className="cam-modal photog-modal" onClick={e=>e.stopPropagation()}>
            <button className="cam-close" onClick={()=>setModal(null)}>✕</button>
            <div style={{textAlign:'center',margin:'8px 0 16px',fontWeight:700, color:'#7b64e8'}}>{modal.feeling}</div>
            <img className="cam-preview" src={`https://api.laviopaperie.com/photo/${modal.filename}`} style={{maxHeight:'52vh',boxShadow:'0 12px 36px #c9c1ef71'}} alt="feeling"/>
            <div className="gal-ts">{modal.timestamp && modal.timestamp.replace('T',' ').replace(/\..+/, '')}</div>
          </div>
        </div>
      )}
    </div>
  );
}
